<script setup lang="ts">
	withDefaults(
		defineProps<{
			statusCode?: number
			title?: string
			description?: string
			link?: string
		}>(),
		{
			statusCode: 501,
			title: 'Oops! Something Went Wrong',
			description: 'Sorry for the inconveniences, we are working to get this error fixed right away.'
		}
	)
	const { value } = useError()
	const reload = () => {
		reloadNuxtApp()
	}
</script>
<template>
	<div id="notfound">
		<div class="notfound flex w-full flex-col items-center justify-center px-[15px]">
			<div class="notfound-404 relative">
				<h1 class="m-0 bg-cover text-[8rem] font-[900] uppercase sm:text-[11.5rem]">
					{{ value?.statusCode || 400 }}
				</h1>
			</div>
			<h2 class="m-0 text-[1.2rem] font-[700] sm:text-[1.63rem]">
				{{ title }}
			</h2>
			<p class="my-5 max-w-md text-center text-sm font-medium uppercase text-gray-400">
				{{ description }}
			</p>
			<nuxt-link v-if="link" :to="link">
				<button
					type="button"
					aria-controls="button"
					class="btn btn-rounded mt-3 h-12 w-[180px] rounded bg-primary-2 text-white transition ease-linear hover:bg-opacity-80"
				>
					<slot name="btnText"> Go home </slot>
				</button>
			</nuxt-link>
			<button
				v-else
				type="button"
				aria-controls="button"
				class="btn btn-rounded mt-3 h-12 w-[180px] rounded bg-primary-2 text-white transition ease-linear hover:bg-opacity-80"
				@click="reload"
			>
				<slot name="btnText"> Reload </slot>
			</button>
		</div>
	</div>
</template>

<style scoped>
	.notfound .notfound-404 h1 {
		background: url('~/assets/images/jpg/error.jpg') center;
		-webkit-background-clip: text;
		background-clip: text;
		max-height: 250px;
		overflow: hidden;
		-webkit-text-fill-color: transparent;
	}

	@media only screen and (max-width: 767px) {
		.notfound .notfound-404 h1 {
			@apply font-[110px];
		}
	}
</style>
